export default {
  viewBox: "0 0 25 24",
  html: "<path fill=\"currentColor\" d=\"m11.047 15.59 1.41 1.41 5-5-5-5-1.41 1.41 2.58 2.59h-9.67v2h9.67zM19.957 3h-14a2 2 0 0 0-2 2v4h2V5h14v14h-14v-4h-2v4a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2\"/>"
};